import { getMarketAppConfig, isPortugalMarket } from '../config/marketRegion';

export function phoneExampleE164(): string {
  return getMarketAppConfig().phone_example_e164_digits;
}

export function defaultPhoneCountryCode(): string {
  return getMarketAppConfig().phone_country_code;
}

/** Valor vazio ou só o indicativo padrão (55 / 351) — não enviar ao backend. */
export function isBarePhonePrefix(value: string): boolean {
  const v = String(value || '').trim();
  const code = defaultPhoneCountryCode();
  return !v || v === code;
}

export function newQuickPatientFormState() {
  const cc = defaultPhoneCountryCode();
  return { full_name: '', cpf: '', phone: cc, whatsapp: cc, email: '', birth_date: '' };
}

export function phoneInputHelperText(): string {
  return isPortugalMarket()
    ? 'Indicativo 351 + 9 dígitos (ex.: 912 345 678). Sem o 351 o sistema completa.'
    : 'DDD + número. Sem o 55 o sistema completa automaticamente.';
}

export function inboxBulkPatientLinkHint(): string {
  return isPortugalMarket()
    ? 'Chats sem paciente cujo telefone coincide com um cadastro (com ou sem indicativo 351).'
    : 'Chats sem paciente cujo telefone coincide com um cadastro (com ou sem 55, DDD com zero e nono dígito).';
}

export function sendDocumentPhoneHelperText(): string {
  return isPortugalMarket()
    ? 'Telemóvel com indicativo 351 — o mesmo cadastrado no prontuário'
    : 'Celular com DDD — o mesmo cadastrado no prontuário';
}

export function formatPhoneForDisplay(phone: string): string {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return phone;

  if (isPortugalMarket()) {
    let national = digits;
    if (national.startsWith('351') && national.length >= 12) national = national.slice(3, 12);
    else if (national.length > 9) national = national.slice(-9);
    if (national.length === 9) {
      return `+351 ${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6)}`;
    }
    return phone;
  }

  let local = digits;
  if (local.startsWith('55') && local.length >= 12) local = local.slice(2);
  if (local.length === 11) {
    const ddd = local.slice(0, 2);
    const rest = local.slice(2);
    return `+55 (${ddd}) ${rest.slice(0, 5)}-${rest.slice(5)}`;
  }
  if (local.length === 10) {
    const ddd = local.slice(0, 2);
    const rest = local.slice(2);
    return `+55 (${ddd}) ${rest.slice(0, 4)}-${rest.slice(4)}`;
  }
  return phone;
}
